import { ElMessage } from "element-plus";
import { post } from "./request";
import { costConfig, ModelEnum } from "./wenxinyiyanConfig";

class Session {
  sessionId: number;
  system: string;
  option: { httpMethod: "get" | "post" };
  constructor(system: string, option?: {
    httpMethod?: 'get' | 'post'
    url?: string,
  }) {
    this.sessionId = Math.round(Math.random() * 100000000)
    this.system = system;
    this.option = {
      httpMethod: 'get',
    };
    if (option?.httpMethod) {
      this.option.httpMethod = option?.httpMethod;
    }
  }
  // 'ernie-4.0-turbo-8k-latest' // 输入0.02     输出：0.06
  // 'ernie-3.5-128k',             // 输入0.0008    输出：0.002
  // 'ernie-3.5-8k-0701',          // 输入0.0008    输出：0.002
  // 'ernie-speed-128k',        // 免费
  chat(
    message: string,
    step?: (val: string) => void,
    { isGiveup, isJSON, isSessionEnd }: {
      isGiveup?: boolean,
      isJSON?: boolean,
      isSessionEnd?: boolean,
    } = { isGiveup: false }
  ): Promise<string> {
    return new Promise<string>(resolve => {
      if (this.option.httpMethod === 'post' || message.length > 800) {// 浏览器限制，所以url不能太长
        post('https://www.microbook123.com/chat/sync', {
          session: this.sessionId,
          message: message,
          system: this.system,
          isGiveup: !!isGiveup,
          isJSON: !!isJSON,
          stream: false,// post不支持EventSource
          isSessionEnd: !!isSessionEnd,
        }).then((res) => {
          console.log('ddddddd', res)
          resolve(res.choices[0].message.content);
        })
        return;
      }
      let returnStr = ''
      const token = localStorage.getItem('token');
      const eventSource = new EventSource(`https://www.microbook123.com/chat/sync?session=${this.sessionId}&token=${token}&message=${encodeURIComponent(message)}&system=${encodeURIComponent(this.system)}&isGiveup=${!!isGiveup}&isJSON=${!!isJSON}&isSessionEnd=${!!isSessionEnd}`);
      eventSource.onopen = function () {
        returnStr = ''
        console.log('连接已打开');
      };
      eventSource.onmessage = function (event) {
        const result = event.data.replace(/^data:\s/, '');
        returnStr += result
        step && step(result)
      };
      eventSource.addEventListener('error', (event) => {
        if (event.eventPhase === EventSource.CLOSED) {
          console.log('Connection was closed.');
          eventSource.close()
          resolve(returnStr)
        } else {
          console.error('An error occurred:', event);
        }
      });
    })
  }
  chatOneTime(
    message: string,
    step?: (val: string) => void,
    { isGiveup, model }: {
      isGiveup?: boolean,
      model?: ModelEnum,
    } = { isGiveup: false }
  ): Promise<string> {
    return new Promise<string>(resolve => {
      const messageObj = JSON.stringify([{
        role: "user",
        content: message
      }]);
      if (this.option.httpMethod === 'post' || messageObj.length > 800) {// 浏览器限制，所以url不能太长
        post('/wenxinyiyan/chat', {
          message: message,
          system: this.system,
          model: model || 'ernie-speed-128k',
          stream: false,// post不支持EventSource
        }).then((res) => {
          const { result, usage } = res;
          const { completion_tokens, prompt_tokens } = usage;
          import('calc-number').then(({ default: calcNumber }) => {
            const cost = costConfig[model || 'ernie-speed-128k'];
            const runStr = `(${prompt_tokens} * ${cost.prompt} + ${completion_tokens} * ${cost.completion})/1000`;
            const costNumber = calcNumber(runStr);
            if (costNumber) {
              ElMessage.info('费用：' + costNumber)
            }
          })
          resolve(result);
        })
        return;
      }
      let returnStr = ''
      const eventSource = new EventSource(`https://www.microbook123.com/wenxinyiyan/chat?message=${encodeURIComponent(messageObj)}&system=${encodeURIComponent(this.system)}&model=${model || 'ernie-speed-128k'}&isGiveup=${!!isGiveup}`);
      eventSource.onopen = function () {
        returnStr = ''
        console.log('连接已打开');
      };
      let lastUsage: any = null;
      eventSource.onmessage = function (event) {
        const jsonStr = event.data.replace(/^data:\s/, '');
        let json;
        try {
          json = JSON.parse(jsonStr)
        } catch (e) {
          console.error(e);
          json = eval(`(${jsonStr})`)
        }
        lastUsage = json.usage;
        returnStr += json.result
        step && step(json.result)
      };
      eventSource.addEventListener('error', (event) => {
        if (event.eventPhase === EventSource.CLOSED) {
          console.log('Connection was closed.');
          eventSource.close()

          import('calc-number').then(({ default: calcNumber }) => {
            if (lastUsage) {
              console.log('lastUsage', lastUsage)
              const { prompt_tokens, completion_tokens } = lastUsage
              const cost = costConfig[model || 'ernie-speed-128k'];
              const runStr = `(${prompt_tokens} * ${cost.prompt} + ${completion_tokens} * ${cost.completion})/1000`;
              console.log('lastUsage', runStr);
              const costNum = calcNumber(runStr);
              console.log('lastUsage', costNum);
              if (costNum > 0) {
                ElMessage.info('费用：' + costNum)
              }
            }
          })
          resolve(returnStr)
        } else {
          console.error('An error occurred:', event);
        }
      });
    })
  }
}
export default Session